import appContainers from './secured/appContainers';
import backArrowBtn from './secured/back-arrow-btn';

export const init = () => {
    appContainers();
    backArrowBtn();
};
